export default function ExternalServices($window) {
    "ngInject";

    /**
     *
     * @param {SbProject} project
     * @returns {*}
     */
    function setActiveProject(project) {
        return $window?.sbServices?.activeProjectService.setActiveProject({
            id: project.id,
            name: project.name,
            purpose: project.purpose,
            language: project.language,
            subscription: project.subscription,
            currencyCode: project.currencyCode,
            account: project.account,
            code: project.code,
            schedulingMode: project.schedulingMode,
            geolocationPermission: project.geolocationPermission,
            inspectCombinedStatusChanges: project.inspectCombinedStatusChanges,
        });
    }

    function unsetActiveProject() {
        return $window?.sbServices?.activeProjectService.unsetActiveProject();
    }

    function setIntercomService(intercomService) {
        $window?.sbServices?.intercomService.setIntercomService(
            intercomService
        );
    }

    function activityTrackerState() {
        return $window?.sbServices?.appActivityTrackerState;
    }

    function getChecklistSequences(deliverableId) {
        return $window?.sbServices?.checklistSequenceService.getChecklistSequences(
            deliverableId
        );
    }

    function showDetailsEventEmitter() {
        return $window?.sbServices?.showDetailsEventEmitter;
    }

    function formatTimestamp(timestamp) {
        return $window?.sbServices?.formatTimestampService.formatTimestamp(
            timestamp
        );
    }

    function analyticsService() {
        return $window?.sbServices?.analyticsService;
    }

    function tourService() {
        return $window?.sbServices?.tourService;
    }

    function router() {
        return $window?.sbServices?.routerBridgeService;
    }

    function noteCreationService() {
        return $window?.sbServices?.angularBridgeNoteCreationService;
    }

    function noteCommentCreationService() {
        return $window?.sbServices?.angularBridgeNoteCommentCreationService;
    }

    function translateServiceTriggerChange(language) {
        return $window?.sbServices?.translateService.triggerLanguageChange(
            language
        );
    }
    function authenticationService() {
        return $window?.sbServices?.authenticationService;
    }

    function noteViewFacadeService() {
        return $window?.sbServices?.noteViewFacade;
    }

    function openImportActivitiesModal(importActivitiesModalData) {
        return $window?.sbServices?.importActivitiesService.onImportClicked(
            importActivitiesModalData
        );
    }

    function openImportPackageModal(importPackageModalData) {
        return $window?.sbServices?.importPackageService.onImportClicked(
            importPackageModalData
        );
    }

    function onTrackerDataChange() {
        return $window?.sbServices?.eventBusService.bridgeEmissions;
    }

    function emitTeamsChange(projectId) {
        return $window?.sbServices?.eventBusService.bridgeEmissions.emitTeamsChange(
            projectId
        );
    }

    function emitChecklistChange(projectId) {
        return $window?.sbServices?.eventBusService.bridgeEmissions.emitChecklistChange(
            projectId
        );
    }

    function emitNoteChange(deliverableId) {
        return $window?.sbServices?.eventBusService.bridgeEmissions.emitNoteChange(
            deliverableId
        );
    }

    function watchTeamsChanges() {
        return $window?.sbServices?.eventBusService.bridgeEvents.watchTeamsChange();
    }

    function watchActivityStateChange() {
        return $window?.sbServices?.eventBusService.bridgeEvents.watchActivityStateChange();
    }

    function onProcessTemplateChange(projectId) {
        return $window?.sbServices?.eventBusService.bridgeEmissions.emitProcessTemplateChange(
            projectId
        );
    }

    function resetActivitiesJob(projectId, resetActivitiesJobDefinition) {
        return $window?.sbServices?.activityJobsRepository.resetActivitiesJob(
            projectId,
            resetActivitiesJobDefinition
        );
    }

    function revertChecklistSigningJob(
        projectId,
        revertChecklistSigningJobDefinition
    ) {
        return $window?.sbServices?.activityJobsRepository.revertChecklistSigningJob(
            projectId,
            revertChecklistSigningJobDefinition
        );
    }

    function emailChange$() {
        return $window?.sbServices?.composeEmailBridgeService.emailChange$.asObservable();
    }
    function projectOverviewSettingsStore() {
        return $window?.sbServices?.projectOverviewSettingsStore;
    }

    function featureFlagsService() {
        return $window?.sbServices?.featureFlagsService;
    }

    function structuresService() {
        return $window?.sbServices?.structuresService;
    }

    function tagsService() {
        return $window?.sbServices?.tagsService;
    }

    function openPdfOptionsDialog() {
        return $window?.sbServices?.printOptionsDialogService.openPdfOptionsDialog();
    }

    function openMigrateChecklistTemplateDialog() {
        return $window?.sbServices?.migrateChecklistTemplateDialogService.openDialog();
    }

    function exif() {
        return $window?.sbServices?.exifService;
    }

    function formatGeolocation(geolocation) {
        return $window?.sbServices?.formatGeolocationService.formatGeolocation(
            geolocation
        );
    }

    function dwfxUploadBridge() {
        return $window?.sbServices?.dwfxUploadBridge;
    }

    function permissionService() {
        return $window?.sbServices?.permissionService;
    }

    function pageAccessService() {
        return $window?.sbServices?.pageAccessService;
    }

    return {
        router,
        setActiveProject,
        unsetActiveProject,
        setIntercomService,
        activityTrackerState,
        getChecklistSequences,
        showDetailsEventEmitter,
        analyticsService,
        noteCreationService,
        noteCommentCreationService,
        translateServiceTriggerChange,
        authenticationService,
        noteViewFacadeService,
        openImportActivitiesModal,
        openImportPackageModal,
        onTrackerDataChange,
        resetActivitiesJob,
        revertChecklistSigningJob,
        emailChange$,
        projectOverviewSettingsStore,
        featureFlagsService,
        structuresService,
        openPdfOptionsDialog,
        openMigrateChecklistTemplateDialog,
        onProcessTemplateChange,
        formatTimestamp,
        exif,
        formatGeolocation,
        emitTeamsChange,
        emitNoteChange,
        watchTeamsChanges,
        watchActivityStateChange,
        tourService,
        tagsService,
        dwfxUploadBridge,
        permissionService,
        pageAccessService,
    };
}
